import { adminHttpClient } from '../../../../commons/adminHttpClient'

export interface BalanceDetail {
  date: string
  allowance: number
  reimbursement: number
  subcategory: number
}

const getBalanceDetails = (userId: string, planPeriodId: string, categoryId: number): Promise<BalanceDetail[]> => {
  return adminHttpClient.get(
    `/AdminDashboard/perks/PerksReimbursementsBalanceDetails/${planPeriodId}/ReimbursementBalance/${userId}/Details`,
    {
      categoryId: categoryId,
    },
  )
}

export default getBalanceDetails
